import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { ADMIN_MANY_ORDERS_API_PATHS } from '../constants/orders-api-paths.constant';
import HttpClient from '../../shared/infrastructures/clients/http.client';
import pluralFormatter from '../../shared/utils/plural-formater';

interface UnarchiveOrdersResponse {
  unarchivedCount: number;
}

export function useUnarchiveOrders() {
  const { enqueueSnackbar } = useSnackbar();
  const [unarchiving, setUnarchiving] = useState(false);

  const unarchiveOrders = async (date: string, ownerRole?: string): Promise<boolean> => {
    setUnarchiving(true);
    try {
      const response = await HttpClient.patch<UnarchiveOrdersResponse>(ADMIN_MANY_ORDERS_API_PATHS.UNARCHIVE, {
        date,
        ownerRole: ownerRole !== 'all' ? ownerRole : undefined,
      });
      enqueueSnackbar(
        pluralFormatter({
          count: response.unarchivedCount,
          singular: `${response.unarchivedCount} commande désarchivée`,
          plural: `${response.unarchivedCount} commandes désarchivées`,
        }),
        { variant: 'success' }
      );
      setUnarchiving(false);
      return true;
    } catch (error) {
      const message = error.response?.data?.message ?? `Une erreur est survenue lors du désarchivage`;
      enqueueSnackbar(message, { variant: 'error' });
      setUnarchiving(false);
      return false;
    }
  };

  return { unarchiving, unarchiveOrders };
}
